<script setup lang="ts">
const { shop, status } = useShop();
</script>

<template>
  <div v-if="status === 'success'" class="text-xl">
    {{ pluralize(shop.products_total, 'produit', 'produits') }}
  </div>
</template>
